import router from './router'
import store from '@/vuex/index'
import Home from '@/views/home/home'
import Detail from '@/views/home/details'
import Hello from '@/views/home/HelloWorld'
// 根据构建模式动态选择登录组件
import Login from '@/views/user/login'
import Library from '@/views/library/index'
import Index from '@/views/index/index'
import Test from '@/views/index/test'
import ProgressRate from '@/views/index/progressRate'
import Record from '@/views/index/record'
import Mod from '@/views/mod/index'
import ActionMod from '@/views/mod/actionMod/index'
import System from '@/views/system/index'
import Log from '@/views/log/index'
import logDetail from '@/views/log/logDetail'
import artistMergeLogDetail from '@/views/log/artistMergeLogDetail'
import AlbumLibrary from '@/views/library/album/AlbumLibrary'
import AlbumDetails from './views/library/album/AlbumDetails'
import ArtistLibrary from './views/library/artist/ArtistLibrary'
import ArtistDetails from './views/library/artist/ArtistDetails'
import ArtistTracks from './views/library/artist/ArtistTracks'
import TrackLibrary from './views/library/track/TrackLibrary'
import GenreLibrary from '@/views/library/genre/GenreLibrary'
import GenreDetails from '@/views/library/genre/GenreDetails'
import Favourites from '@/views/library/favourite/Favourites'
import Playing from '@/views/library/playing/Queue'
import xiaoMiQueue from '@/views/library/playing/xiaoMiQueue'
import dlnaQueue from '@/views/library/playing/dlnaQueue'
import queueIndex from '@/views/library/playing/queueIndex'
import GroupCast from '@/views/library/playing/groupcast'
import Discover from '@/views/library/discover'
import PlayingList from '@/views/library/playing/PlayingDetails'
import PlayListLibrary from '@/views/library/playlist/PlaylistLibrary'
import PlayList from '@/views/library/playlist/Playlist'
import SharedPlaylist from '@/views/library/playlist/SharedPlaylist'
// const _import = require('./router/_import_' + process.env.NODE_ENV) // 获取组件的方法

let getRouter // 用来获取后台拿到的路由
// let getMenuList // 用来获取后台拿到的菜单

// 开发环境下清除路由缓存,确保使用最新的登录组件
if (process.env.NODE_ENV === 'development') {
    console.log('🔄 开发模式: 清除路由缓存')
    localStorage.removeItem('router')
}

saveObjArr('router', '')

/**
 * 根据用户角色获取默认路由路径
 * @param {boolean} isSuperuser - 是否为超级用户(收藏家)
 * @returns {string} 默认路由路径
 */
function getDefaultRouteByRole(userInfo) {
    if (userInfo.userRole === 'V1'){
        return '/'
    }
    if (userInfo.isSuperuser === true) {
        // 收藏家跳转到控制台
        return '/'
    } else {
        // 普通听众跳转到音乐收藏馆
        return '/discover'
    }
}

/**
 * 定义角色可访问的路由路径
 */
const ROLE_ROUTE_MAP = {
    'V1': [
        '/',           // 操作台
        '/home',       // 操作台
        '/log',        // 操作记录
        '/log_detail', // 日志详情(允许访问子路由)
        '/artist_merge_log_detail', // 艺术家合并日志详情
        '/detail',     // 详情页
        '/hello'       // Hello页面
    ],
    'V2': 'all'  // V2用户可以访问所有页面
}

/**
 * 检查用户是否有权限访问指定路由
 * @param {string} path - 路由路径
 * @param {string} userRole - 用户角色
 * @param {boolean} isSuperuser - 是否为超级用户
 * @returns {boolean} 是否有权限
 */
function hasRoutePermission(path, userRole, isSuperuser) {
    // V2 角色可以访问所有页面
    if (userRole === 'V2') {
        return true
    }

    // V1 角色只能访问指定的页面
    if (userRole === 'V1') {
        const allowedRoutes = ROLE_ROUTE_MAP['V1']

        // 检查是否在允许的路由列表中
        // 支持精确匹配和前缀匹配(用于子路由)
        return allowedRoutes.some(route => {
            if (path === route) {
                return true
            }
            // 检查是否为允许路由的子路由
            if (path.startsWith(route + '/')) {
                return true
            }
            return false
        })
    }

    // 默认拒绝访问
    return false
}

/**
 * 处理权限检查逻辑
 * @param {Object} to - 目标路由
 * @param {Object} from - 来源路由
 * @param {Function} next - 路由继续函数
 */
function handlePermissionCheck(to, from, next) {
    // 检查是否需要登录
    if (to.path === '/login') {
        next()
        return
    }
    // 获取用户权限信息
    const userInfo = store.state.common

    // 修复：检查用户信息是否已经加载完成
    // 用户信息未加载的标识：username为空字符串（初始值）
    if (!userInfo.username || userInfo.username === '') {
        // 用户信息还未加载，允许继续但会在组件中处理权限
        next()
        return
    }
    // 处理首页权限跳转逻辑
    if (to.path === '/' || (to.name === 'home' && to.meta && to.meta.requiresAuth)) {
        const defaultRoute = getDefaultRouteByRole(userInfo)
        if (to.path !== defaultRoute) {
            // 重定向到对应的默认页面
            next({ path: defaultRoute, replace: true })
            return
        }
    }
    // 检查页面权限（如果需要的话，可以扩展更多权限控制）
    if (to.meta && to.meta.requiresSuperuser && !userInfo.isSuperuser) {
        // 如果页面需要管理员权限但用户不是管理员，跳转到音乐收藏馆
        next({ path: '/library', replace: true })
        return
    }

    // 基于角色的路由访问控制
    if (!hasRoutePermission(to.path, userInfo.userRole, userInfo.isSuperuser)) {
        console.warn(`用户 ${userInfo.username} (角色: ${userInfo.userRole}) 尝试访问未授权的路由: ${to.path}`)

        // 根据用户角色重定向到默认页面
        const defaultRoute = getDefaultRouteByRole(userInfo)
        next({ path: defaultRoute, replace: true })

        // 可选：显示提示消息
        // 注意：这里需要确保 $myMsg 已经初始化
        setTimeout(() => {
            if (window.vm && window.vm.$myMsg) {
                window.vm.$myMsg.notify({
                    title: '访问受限',
                    content: '您没有权限访问该页面',
                    type: 'warning',
                    time: 3000
                })
            }
        }, 100)

        return
    }

    next()
}

router.beforeEach((to, from, next) => {
    // 如果是应用模式且没有配置服务器地址,强制跳转到登录页
    if (window.needsServerConfig && to.path !== '/login') {
        console.log('未配置服务器地址,跳转到登录页')
        next({ path: '/login', replace: true })
        return
    }

    if (!getRouter) { // 不加这个判断，路由会陷入死循环
        if (!getObjArr('router')) {
            getRouter = [
                {
                    'path': '/',
                    'name': 'home',
                    'component': 'Home',
                    'meta': {
                        'title': '控制台',
                        'requiresAuth': true,  // 标记需要权限检查
                        'index': 2
                    }
                },
                {
                    'path': '/detail',
                    'name': 'detail',
                    'component': 'Detail',
                    'meta': {
                        'title': '音流详情'
                    }
                },
                {
                    'path': '/hello',
                    'name': 'hello',
                    'component': 'Hello',
                    'meta': {
                        'title': '控制台'
                    }
                },
                {
                    'path': '/log',
                    'name': 'log',
                    'component': 'Log',
                    'meta': {
                        'title': '操作记录',
                        'index': 3
                    }
                },
                {
                    'path': '/test',
                    'name': 'test',
                    'component': 'Test',
                    'meta': {
                        'title': '操作记录'
                    }
                },
                {
                    'path': '/log_detail/:id/',
                    'name': 'log_detail',
                    'component': 'logDetail',
                    'meta': {
                        'title': '日志详情',
                        'fatherName': 'log'
                    }
                },
                {
                    'path': '/artist_merge_log_detail/:id/',
                    'name': 'artist_merge_log_detail',
                    'component': 'artistMergeLogDetail',
                    'meta': {
                        'title': '艺术家合并日志详情',
                        'fatherName': 'log'
                    }
                },
                {
                    'path': '/library',
                    'name': 'library',
                    'component': 'Library',
                    'meta': {
                        'title': '音乐收藏馆',
                        keepAlive: true,
                        'index': 4
                    },
                    'children': [
                        {
                            'path': '/albums/:sort',
                            'name': 'albums',
                            'component': 'AlbumLibrary',
                            'meta': {
                                'title': '专辑收藏',
                                'fatherName': 'library',
                                keepAlive: true,
                                'index': 4
                            }
                        },
                        {
                            'path': '/album/id/:id',
                            'name': 'album',
                            'component': 'AlbumDetails',
                            'meta': {
                                'title': '专辑详情',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/tracks/:sort',
                            'name': 'tracks',
                            'component': 'TrackLibrary',
                            'meta': {
                                'title': '歌曲收藏',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/artists/:sort',
                            'name': 'artists',
                            'component': 'ArtistLibrary',
                            'meta': {
                                'title': '艺术家列表',
                                'fatherName': 'library',
                                keepAlive: true
                            }
                        },
                        {
                            'path': '/artist/id/:id',
                            'name': 'artist',
                            'component': 'ArtistDetails',
                            'meta': {
                                'title': '艺术家详情',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/artist/tracks/:id',
                            'name': 'artist-tracks',
                            'component': 'ArtistTracks',
                            'meta': {
                                'title': '艺术家详情',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/genres/:sort',
                            'name': 'genres',
                            'component': 'GenreLibrary',
                            'meta': {
                                'title': '风格列表',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/genre/id/:id',
                            'name': 'genre',
                            'component': 'GenreDetails',
                            'meta': {
                                'title': '风格详情',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/favourites/:sort',
                            'name': 'favourites',
                            'component': 'Favourites',
                            'meta': {
                                'title': '收藏',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/discover',
                            'name': 'discover',
                            'component': 'Discover',
                            'meta': {
                                'title': '发现音乐',
                                'fatherName': 'library',
                                'index': 4
                            }
                        },
                        {
                            'path': '/playing',
                            'name': 'playing',
                            'component': 'Playing',
                            'meta': {
                                'title': '正在播放',
                                'fatherName': 'library'
                            },
                            'children': [
                                {
                                    'path': '',
                                    'redirect': 'local'
                                },
                                {
                                    'path': 'local',
                                    'name': 'playing-local',
                                    'component': 'dlnaQueue',
                                    'meta': {
                                        'title': '音乐播放',
                                        'fatherName': 'library'
                                    }
                                },
                                {
                                    'path': 'xiaomi',
                                    'name': 'playing-xiaomi',
                                    'component': 'xiaoMiQueue',
                                    'meta': {
                                        'title': '小爱音箱播放',
                                        'fatherName': 'library'
                                    }
                                },
                            ]
                        },
                        {
                            'path': '/xiaoMiQueue',
                            'name': 'xiaoMiQueue',
                            'component': 'xiaoMiQueue',
                            'meta': {
                                'title': '小爱播放',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/dlnaQueue',
                            'name': 'dlnaQueue',
                            'component': 'dlnaQueue',
                            'meta': {
                                'title': 'DLNA播放',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/queueIndex',
                            'name': 'queueIndex',
                            'component': 'queueIndex',
                            'meta': {
                                'title': '播放设备选择',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/groupcast',
                            'name': 'groupcast',
                            'component': 'GroupCast',
                            'meta': {
                                'title': '多端同播',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/playing/id/:id',
                            'name': 'playingList',
                            'component': 'PlayingList',
                            'meta': {
                                'title': '播放详情',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/playlists/:sort',
                            'name': 'playlists',
                            'component': 'PlayListLibrary',
                            'meta': {
                                'title': '播放列表',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/playlist/:id',
                            'name': 'playlist',
                            'component': 'PlayList',
                            'meta': {
                                'title': '播放列表',
                                'fatherName': 'library'
                            }
                        },
                        {
                            'path': '/shared/playlist/:shareCode',
                            'name': 'sharedPlaylist',
                            'component': 'SharedPlaylist',
                            'meta': {
                                'title': '分享的播放列表',
                                'fatherName': 'library'
                            }
                        }
                    ]
                },
                {
                    'path': '/index',
                    'name': 'index',
                    'component': 'Index',
                    'meta': {
                        'title': '首页',
                        'index': 1
                    }
                },
                {
                    'path': '/progress',
                    'name': 'progress',
                    'component': 'ProgressRate',
                    'meta': {
                        'title': '刮削完整度',
                        'fatherName': 'index'
                    }
                },
                {
                    'path': '/record',
                    'name': 'record',
                    'component': 'Record',
                    'meta': {
                        'title': '音乐记录',
                        'fatherName': 'index'
                    }
                },
                {
                    'path': '/mod',
                    'name': 'mod',
                    'component': 'Mod',
                    'meta': {
                        'title': '插件管理',
                        'requiresSuperuser': true  // 需要管理员权限
                    }
                },
                {
                    'path': '/actionMod',
                    'name': 'actionMod',
                    'component': 'ActionMod',
                    'meta': {
                        'title': '插件管理',
                        'fatherName': 'mod',
                        'requiresSuperuser': true  // 需要管理员权限
                    }
                },
                {
                    'path': '/system',
                    'name': 'system',
                    'component': 'System',
                    'meta': {
                        'title': '系统设置',
                        'requiresSuperuser': false,  // 需要管理员权限
                        'index': 5
                    }
                },
                {
                    'path': '/login',
                    'name': 'login',
                    'component': 'Login',
                    'meta': {
                        'title': '登录'
                    }
                }
            ]
            saveObjArr('router', getRouter) // 存储路由到localStorage
            routerGo(to, next) // 执行路由跳转方法
        } else { // 从localStorage拿到了路由
            getRouter = getObjArr('router') // 拿到路由
            routerGo(to, next)
        }
    } else {
        // 处理权限控制逻辑
        handlePermissionCheck(to, from, next)
    }
})

function routerGo(to, next) {
    getRouter = filterAsyncRouter(getRouter) // 过滤路由
    router.addRoutes(getRouter) // 动态添加路由
    store.state.antRouter = getRouter // 将路由数据传递给全局变量
    // store.state.displayMenu = getMenuList //将菜单数据传递给全局变量，做侧边栏菜单渲染工作
    // store.state.displayButton = getButton // 将按钮权限数据传递给全局变量，做页面按钮权限渲染工作
    next({
        ...to,
        replace: true
    })
}

function saveObjArr(name, data) { // localStorage 存储数组对象的方法
    localStorage.setItem(name, JSON.stringify(data))
}

function getObjArr(name) { // localStorage 获取数组对象的方法
    return JSON.parse(window.localStorage.getItem(name))
}

const ROUTER_MAP = {
    'Home': Home,
    'Detail': Detail,
    'Login': Login,
    'Library': Library,
    'Index': Index,
    'Test': Test,
    'ProgressRate': ProgressRate,
    'Record': Record,
    'Mod': Mod,
    'System': System,
    'ActionMod': ActionMod,
    'Log': Log,
    'logDetail': logDetail,
    'artistMergeLogDetail': artistMergeLogDetail,
    'AlbumLibrary': AlbumLibrary,
    'AlbumDetails': AlbumDetails,
    'ArtistLibrary': ArtistLibrary,
    'ArtistDetails': ArtistDetails,
    'ArtistTracks': ArtistTracks,
    'TrackLibrary': TrackLibrary,
    'GenreLibrary': GenreLibrary,
    'GenreDetails': GenreDetails,
    'Favourites': Favourites,
    'Playing': Playing,
    'xiaoMiQueue': xiaoMiQueue,
    'dlnaQueue': dlnaQueue,
    'queueIndex': queueIndex,
    'GroupCast': GroupCast,
    'Discover': Discover,
    'PlayListLibrary': PlayListLibrary,
    'PlayList': PlayList,
    'SharedPlaylist': SharedPlaylist,
    'PlayingList': PlayingList,
    'Hello': Hello,
}

function filterAsyncRouter(asyncRouterMap) { // 遍历后台传来的路由字符串，转换为组件对象
    const accessedRouters = asyncRouterMap.filter(route => {
        if (route.component) {
            route.component = ROUTER_MAP[route.component]
        }
        if (route.children && route.children.length) {
            route.children = filterAsyncRouter(route.children)
        }
        return true
    })
    return accessedRouters
}

// 用来控制按钮的显示与否
export function hasPermission(permission) {
    const myBtns = store.state.permission.btnPermission
    for (let i = 0; i < myBtns.length; i++) {
        if (myBtns[i].url === permission) {
            return myBtns[i].auth
        }
    }
}
